import { Approver } from "../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.utils";
import { OptionType } from "./RulesModal.types";
import { TemplateRuleRow } from "./RulesModal.types";

/**
 * Convert object {0: "=", 1: "!="} into react-select options.
 */
export const optionRenderer = (obj: Record<number, string>): OptionType[] => {
  return Object.values(obj).map(v => ({ value: v, label: v }));
};


/**
  * Compares two lists of approvers and checks if they are equal.
  * Equality is determined by comparing the `FirmDetailId` of each approver after sorting.
  *
  * @param a - The first list of approvers.
  * @param b - The second list of approvers.
  * @returns `true` if both lists contain the same approvers in any order, otherwise `false`.
  */
export const areApproversEqual = (a: Approver[], b: Approver[]): boolean => {
  if (a.filter((approver) => approver.Active === "Y").length !== b.filter((approver) => approver.Active === "Y").length) return false;

  const sortById = (list: Approver[]) =>
    [...list].sort((x, y) => (x.FirmDetailId ?? 0) - (y.FirmDetailId ?? 0));

  const sortedA = sortById(a);
  const sortedB = sortById(b);

  return sortedA.every(
    (item, index) => item.FirmDetailId === sortedB[index].FirmDetailId && item.Active === sortedB[index].Active
  );
};

export const areRulesEqual = (arr1: TemplateRuleRow[], arr2: TemplateRuleRow[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  const normalize = (rules: TemplateRuleRow[]) =>
    rules
      .filter((r) => r.Active !== "N")
      .map((r) => ({
        SelectedFieldValue: r.SelectedFieldValue,
        SelectedFieldLabel: r.SelectedFieldLabel,
        Operator: r.Operator,
        ConditionValue: r.ConditionValue,
      }))
      .sort((a, b) =>
        `${a.SelectedFieldValue}-${a.Operator}-${a.ConditionValue}`.localeCompare(
          `${b.SelectedFieldValue}-${b.Operator}-${b.ConditionValue}`
        )
      );

  const norm1 = normalize(arr1);
  const norm2 = normalize(arr2);

  return JSON.stringify(norm1) === JSON.stringify(norm2);
};
